import React from "react";

/**
 * DDS-001 · Chapter 10 · §2.9 · Mandatory Universal Footer.
 * ────────────────────────────────────────────────────────
 * Every Emergency surface — landing, each choice screen, every
 * playbook, every Binder Emergency page, every printable Emergency
 * Booklet page, every push-notification detail view — MUST include
 * this footer.
 *
 * Rules (from Chapter 10 §2.9):
 *   · Positioned at the bottom, above any legal/copyright rows.
 *   · Never truncated.
 *   · Never removed.
 *   · Localised into other languages; never localised away.
 *   · Read aloud last by screen readers.
 *
 * Do not stylise, animate, or embellish this component. It is a
 * governance artefact expressing Cruise Command's second-line-
 * assistance posture. Its visual weight is deliberately quiet.
 */
export function EmergencyFooter({ className }) {
  return (
    <footer
      data-testid="cc-emergency-footer"
      role="contentinfo"
      aria-label="Cruise Command safety notice"
      className={`cc-emergency-footer ${className || ""}`}
    >
      <em>
        In any shipboard emergency, always follow crew instructions
        immediately.
      </em>
    </footer>
  );
}

export default EmergencyFooter;
